module.exports = {
        srcSet: __webpack_public_path__ + "static/media/section3-500.2cd90547.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/section3-500.2cd90547.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/section3-500.2cd90547.webp",
        toString: function(){return __webpack_public_path__ + "static/media/section3-500.2cd90547.webp"},
        
        width: 500,
        height: 500
      }